import { Role } from '../enums/role.enum';
import { CurrentUser } from './current-user';

export class AdminUser implements CurrentUser {
  email: string;

  fullName: string;

  role: Role;

  defaultUrl: string;

  constructor(user: any) {
    this.email = user.email;
    this.fullName = user.representativeName;
    this.role = user.role;
    this.defaultUrl = '/companies';
  }
}
